module.exports = __webpack_public_path__ + "8a0aad43.png";